export default __webpack_public_path__ + "static/media/logo-ufo.5321cee9.svg";